// import { YMInitializer } from 'react-yandex-metrika'
import { ReactNode } from 'react'
import { App as AntdApp } from 'antd'
// import { IS_PROD } from '@/constants/env'
import { AntDesignConfigProvider } from './antDesign/AntDesign'

export const AppProvider = ({ children }: { children: ReactNode }) => {
  return (
    <AntdApp>
      <AntDesignConfigProvider>
        {/* {IS_PROD && !IS_FSSP && (
          <YMInitializer
            accounts={[97328220]}
            options={{
              clickmap: true,
              trackLinks: true,
              accurateTrackBounce: true
            }}
            version='2'
          />
        )} */}
        {children}
      </AntDesignConfigProvider>
    </AntdApp>
  )
}
